import React, { useState, useEffect } from "react";
import { Dropdown } from "primereact/dropdown";
import { Button } from "primereact/button";
import { useFormik } from "formik";
import classNames from "classnames";
import { useDispatch, useSelector } from "react-redux";
import AuthMatrixDetails from "./AuthMatrixDetails";
import { handleGetRequest } from "../../../services/GetTemplate";
import { handlePostRequest } from "../../../services/PostTemplate";
import { handlePutRequest } from "../../../services/PutTemplate";
import { GetAuthMatrixFurtherDetailsAction } from "../../../redux/actions/companyAction";
import * as Yup from "yup";
import { toast } from "react-toastify";
import { useHistory } from "react-router-dom";

function AddEditAuthMatrixDetails({ companyId, authMatrixHeadId, squentailStateDisable, editable }) {

    const [loading, setloading] = useState(false);
    const [loadingIcon, setloadingIcon] = useState("pi pi-save");
    const [userOptions, setuserOptions] = useState([]);
    const [userLevelOptions, setuserLevelOptions] = useState([]);
    const [authMatrixDetailId, setauthMatrixDetailId] = useState("");
    const [editFlag, seteditFlag] = useState(false);
    const dispatch = useDispatch();
    const history = useHistory()

    useEffect(() => {
        handleGetRequest("zbizgateway/lov/lovCompanyUsers/" + companyId).then((res) => {
            setuserOptions(res?.data);
        });
    }, []); // eslint-disable-line

    useEffect(() => {
        handleGetRequest("zbizgateway/lov/lovUserLevel").then((res) => {
            setuserLevelOptions(res?.data);
        });
    }, []);

    const authMatrixHeadId__Store = useSelector((state) => state.companySlice?.companyAuthMatrixDetailsForm?.authMatrixHeadId);

    const fillAuthMatrixDetailsForm = (data) => {
        const userLevelId = { code: data?.lkpUserAuthLevel?.userAuthLevelCode, description: data?.lkpUserAuthLevel?.userAuthLevelName, id: data?.lkpUserAuthLevel?.userAuthLevelId.toString(), longText: null, shortText: null };
        const userId = { code: data?.tblUser?.userCode, description: data?.tblUser?.userName, id: data?.tblUser?.userId.toString(), longText: null, shortText: null };
        formik.setFieldValue("srNo", data?.srNo);
        formik.setFieldValue("userId", userId);
        formik.setFieldValue("userLevelId", userLevelId);
        setauthMatrixDetailId(data?.authMatrixDetailId);
        seteditFlag(true);
    };

    const validationSchema = Yup.object().shape({
        userId: Yup.mixed().required("This field is required."),
        userLevelId: Yup.mixed().required("This field is required."),
    });

    const formik = useFormik({
        validationSchema: validationSchema,
        initialValues: {
            userId: "",
            userLevelId: "",
            isSequential: "N",
            srNo: "",
            toAmount: "",
        },
        onSubmit: async (data) => {
            try {
                setloading(true);
                setloadingIcon("pi pi-spin pi-spinner");

                data["userId"] = data?.userId?.id;
                data["userLevelId"] = data?.userLevelId?.id;

                const authMatrixId = localStorage.getItem("authMatrixHeadId")

                if (editFlag === true) {
                    data["authMatrixDetailId"] = authMatrixDetailId;
                    data["userId"] = parseInt(data?.userId);
                    data["userLevelId"] = parseInt(data?.userLevelId);
                    data["srNo"] = data?.srNo.toString();
                    delete data["isSequential"];
                    delete data["toAmount"];
                    await handlePutRequest(data, "zbizgateway/nonFin/updateCompanyAuthMatrixDetail");
                    await dispatch(GetAuthMatrixFurtherDetailsAction("zbizgateway/nonFin/getAuthMatrix/" + authMatrixHeadId__Store));
                } else {
                    let headId = "";
                    if (authMatrixId === null || authMatrixId === undefined || authMatrixId === "") {
                        headId = authMatrixHeadId__Store;
                        toast.error("Please select a Company Account Authorization Matrix first.")
                        return
                    } else {
                        headId = authMatrixId;
                    }
                    data["authMatrixHeadId"] = headId;
                    await handlePostRequest(data, "zbizgateway/nonFin/saveCompanyAuthMatrixDetail");
                    await dispatch(GetAuthMatrixFurtherDetailsAction("zbizgateway/nonFin/getAuthMatrix/" + headId));
                }

                formik.resetForm();
                seteditFlag(false);
            } catch (error) {
                console.error("An error occurred:", error);
            } finally {
                setloading(false);
                setloadingIcon("pi pi-save");
            }
        },
    });
    const isFormFieldValid = (name) => !!(formik.touched[name] && formik.errors[name]);
    const getFormErrorMessage = (name) => {
        return isFormFieldValid(name) && <small className="p-error">{formik.errors[name]}</small>;
    };

    useEffect(() => {
        formik.setFieldValue("userId", "")
        formik.setFieldValue("userLevelId", "")
    }, []);

    return (
        <div>
            <div className="page_header">
                <div className="Top__Btn" style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                    <div className="d_align">
                        <i className="pi pi-arrow-circle-left mr-1" onClick={() => history.goBack()} />
                        <h3 className="mod_heading">Authorization Matrix Details</h3>
                    </div>
                </div>
            </div>

            <div className="card Card__Round">
                <form onSubmit={formik.handleSubmit} className="p-fluid p-mt-2 pos_relative">
                    <div className="p-fluid p-formgrid p-grid">
                        <div className="p-field p-col-12 p-md-6">
                            <div className="p-field">
                                <label htmlFor="userId" className={classNames({ "p-error": isFormFieldValid("userId") }, "Label__Text")}>
                                    User<span className="Label__Required">*</span>
                                </label>
                                <Dropdown id="userId" placeholder="Enter User" options={userOptions} optionLabel="description" name="userId" value={formik.values.userId} onChange={formik.handleChange} className={classNames({ "p-invalid": isFormFieldValid("userId") }, "Dropdown__Round")} />
                                {getFormErrorMessage("userId")}
                            </div>
                        </div>
                        <div className="p-field p-col-12 p-md-6">
                            <div className="p-field">
                                <label htmlFor="userLevelId" className={classNames({ "p-error": isFormFieldValid("userLevelId") }, "Label__Text")}>
                                    User Level<span className="Label__Required">*</span>
                                </label>
                                <Dropdown
                                    id="userLevelId"
                                    placeholder="Enter User Level"
                                    options={userLevelOptions}
                                    optionLabel="description"
                                    name="userLevelId"
                                    value={formik.values.userLevelId}
                                    onChange={formik.handleChange}
                                    className={classNames({ "p-invalid": isFormFieldValid("userLevelId") }, "Dropdown__Round")}
                                />
                                {getFormErrorMessage("userLevelId")}
                            </div>
                        </div>
                    </div>
                    {
                        editable === "view" ? (<div className="overlay_field"></div>) : ""
                    }
                    {editable === "true" ? (
                        <div className="GenerateDown__Btn p-mt-4">
                            <Button disabled={authMatrixHeadId === undefined || authMatrixHeadId === null || authMatrixHeadId__Store !== undefined ? false : loading} label={editFlag ? "Update" : "Add"} className="Btn__Transparent" />
                        </div>
                    ) : null}
                </form>
                <AuthMatrixDetails fillAuthMatrixDetailsForm={fillAuthMatrixDetailsForm} />
            </div>
        </div>
    );
}

export default AddEditAuthMatrixDetails;
